export const DEFAULT_BG_COLOR = "#1A1A1A";